export default "__VITE_ASSET__Dk4hOiVw__"